var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import di from "../SalesReporting/di/serviceLocator";
import Loader from "@frameworks/shared-library/components/Loader";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import "@frameworks/salesjourney/stylesheets/components/Features/SalesReporting/SupersetReport.scss";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
var SupersetReport = function () {
    var _a = __read(useState(true), 2), loader = _a[0], setLoader = _a[1];
    var _b = useParams(), dashboardId = _b.dashboardId, title = _b.title;
    var token = jwtDecode(localStorage.getItem("access_token"));
    var empName = (token === null || token === void 0 ? void 0 : token.employeeName) || "";
    var _c = __read(empName.split(" ") || [], 2), firstName = _c[0], lastName = _c[1];
    var employeeCode = (token === null || token === void 0 ? void 0 : token.employeeCode) || "";
    var fetchGuestTokenAndEmbed = function () {
        setLoader(true);
        var payload = {
            user_payload: {
                username: employeeCode || "",
                first_name: firstName,
                last_name: lastName,
            },
            dashboard_id: dashboardId,
        };
        di.salesReporting
            .getGuestTokenAndEmbed(payload)
            .then(function (resp) {
            var guestToken = resp.token;
            embedDashboard({
                id: dashboardId,
                supersetDomain: URLConfig.config.supersetDomain,
                mountPoint: document.getElementById("superset-container"),
                fetchGuestToken: function () { return Promise.resolve(guestToken); },
                dashboardUiConfig: {
                    hideTitle: true,
                    filters: {
                        expanded: true,
                        visible: true,
                    },
                },
                iframeSandboxExtras: [
                    "allow-top-navigation",
                    "allow-popups-to-escape-sandbox",
                ],
            });
            var iframe = document.querySelector("iframe");
            if (iframe) {
                iframe.style.width = "100%";
                iframe.style.height = "80vh";
                iframe.style.border = "none";
                iframe.style.overflow = "hidden";
            }
            setLoader(false);
        })
            .catch(function (error) {
            setLoader(false);
        });
    };
    useEffect(function () {
        fetchGuestTokenAndEmbed();
    }, [dashboardId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GridContainer, { parentClass: "rm-partner-report-dashboard position-relative" },
            loader ? React.createElement(Loader, null) : React.createElement(React.Fragment, null),
            React.createElement("div", { className: "heading-search-container d-flex align-items-center justify-content-between" }),
            React.createElement("div", { id: "superset-container" }),
            React.createElement("div", { className: "superset-container-wrapper" }))));
};
export default SupersetReport;
